import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://bravoaustinpt.com";
const DEFAULT_IMAGE = `${SITE_URL}/bravo-header.png`;
const DEFAULT_AUTHOR = "Dr. Jackie West, Bravo Physical Therapy";

const SEO = ({
  title,
  description,
  keywords,
  path,
  ogDescription,
  twitterDescription,
  image = DEFAULT_IMAGE,
  robots = "index, follow",
  author = DEFAULT_AUTHOR,
}) => {
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={twitterDescription || ogDescription || description} />
      <meta name="twitter:image" content={image} />
      <meta name="robots" content={robots} />
      <meta name="author" content={author} />
    </Helmet>
  );
};

export default SEO;
